import { render, staticRenderFns } from "./home_product_2.vue?vue&type=template&id=7be6337e&scoped=true"
import script from "./home_product_2.vue?vue&type=script&lang=js"
export * from "./home_product_2.vue?vue&type=script&lang=js"
import style0 from "./home_product_2.vue?vue&type=style&index=0&id=7be6337e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be6337e",
  null
  
)

export default component.exports